import { render, staticRenderFns } from "./product_conditions_of_use_and_storage.vue?vue&type=template&id=363e6488&scoped=true&"
import script from "./product_conditions_of_use_and_storage.vue?vue&type=script&lang=js&"
export * from "./product_conditions_of_use_and_storage.vue?vue&type=script&lang=js&"
import style0 from "./product_conditions_of_use_and_storage.vue?vue&type=style&index=0&id=363e6488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e6488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363e6488')) {
      api.createRecord('363e6488', component.options)
    } else {
      api.reload('363e6488', component.options)
    }
    module.hot.accept("./product_conditions_of_use_and_storage.vue?vue&type=template&id=363e6488&scoped=true&", function () {
      api.rerender('363e6488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_conditions_of_use_and_storage.vue"
export default component.exports